import { render, staticRenderFns } from "./DateRangePickerItem.vue?vue&type=template&id=15506bf5&scoped=true"
import script from "./DateRangePickerItem.vue?vue&type=script&lang=js"
export * from "./DateRangePickerItem.vue?vue&type=script&lang=js"
import style0 from "./DateRangePickerItem.vue?vue&type=style&index=0&id=15506bf5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15506bf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15506bf5')) {
      api.createRecord('15506bf5', component.options)
    } else {
      api.reload('15506bf5', component.options)
    }
    module.hot.accept("./DateRangePickerItem.vue?vue&type=template&id=15506bf5&scoped=true", function () {
      api.rerender('15506bf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/DateRangePickerItem.vue"
export default component.exports